/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Additionalstudyinterests_Study_Biophysics17Inputs */

const en__field__enum_additionalstudyinterests_study_biophysics17 = /** @type {(inputs: _Field__Enum_Additionalstudyinterests_Study_Biophysics17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biophysics`)
};

const de__field__enum_additionalstudyinterests_study_biophysics17 = /** @type {(inputs: _Field__Enum_Additionalstudyinterests_Study_Biophysics17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biophysik`)
};

/**
* | output |
* | --- |
* | "Biophysics" |
*
* @param {_Field__Enum_Additionalstudyinterests_Study_Biophysics17Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_additionalstudyinterests_study_biophysics17 = /** @type {((inputs?: _Field__Enum_Additionalstudyinterests_Study_Biophysics17Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Additionalstudyinterests_Study_Biophysics17Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_additionalstudyinterests_study_biophysics17(inputs)
	return de__field__enum_additionalstudyinterests_study_biophysics17(inputs)
});
export { _field__enum_additionalstudyinterests_study_biophysics17 as "_field__enum_additionalStudyInterests_STUDY_BIOPHYSICS" }